import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import './Footer.css';
import logo from '../../assets/logo.jpg';

const Footer = () => {
  const [isAuthenticated, setIsAuthenticated] = useState(false);
  const [user, setUser] = useState(null);

  useEffect(() => {
    const auth = localStorage.getItem('isAuthenticated') === 'true';
    const userData = localStorage.getItem('user');
    setIsAuthenticated(auth);
    setUser(userData ? JSON.parse(userData) : null);
  }, []);

  const handleLogout = () => {
    localStorage.removeItem('isAuthenticated');
    localStorage.removeItem('user');
    setIsAuthenticated(false);
    setUser(null);
    window.location.href = '/';
  };

  return (
    <footer className="footer">
      <div className="container">
        {/* Contact Sections */}
        <div className="contact-sections">
          {/* Northern Region */}
          <div className="region">
            <h3 className="region-title">KHU VỰC MIỀN BẮC</h3>
            <div className="region-content">
              <div className="city">
                <h4 className="city-title">Hà Nội</h4>
                <p className="city-info">
                  <svg className="icon location-icon" />
                  Lancaster Building - 20 Núi Trúc - Giảng Võ - Ba Đình - Hà Nội
                </p>
                <p className="city-info">
                  <svg className="icon phone-icon" />
                  024 6671 8333
                </p>
              </div>
              <div className="city">
                <h4 className="city-title">Hải Phòng</h4>
                <p className="city-info">
                  <svg className="icon location-icon" />
                  Tầng 6 - Bạch Đằng Tower - 268 Trần Nguyên Hãn - Lê Chân
                </p>
                <p className="city-info">
                  <svg className="icon phone-icon" />
                  0225 3787 383
                </p>
              </div>
            </div>
          </div>

          {/* Central Region */}
          <div className="region">
            <h3 className="region-title">KHU VỰC MIỀN TRUNG</h3>
            <div className="region-content">
              <div className="city">
                <h4 className="city-title">Đà Nẵng</h4>
                <p className="city-info">
                  <svg className="icon location-icon" />
                  Số 236-238 - Đường 30/4 - Q.Hải Châu
                </p>
                <p className="city-info">
                  <svg className="icon phone-icon" />
                  0236 656 3939
                </p>
              </div>
              <div className="city">
                <h4 className="city-title">Huế</h4>
                <p className="city-info">
                  <svg className="icon location-icon" />
                  Shophouse A21 - The Manor Crown - 62 Tố Hữu
                </p>
                <p className="city-info">
                  <svg className="icon phone-icon" />
                  0234 6265 999
                </p>
              </div>
            </div>
          </div>

          {/* Southern Region */}
          <div className="region">
            <h3 className="region-title">KHU VỰC MIỀN NAM</h3>
            <div className="region-content">
              <div className="city">
                <h4 className="city-title">TP Hồ Chí Minh CS1</h4>
                <p className="city-info">
                  <svg className="icon location-icon" />
                  Tầng 1 - Tòa nhà Orient - 331 Bến Vân Đồn - Quận 4
                </p>
                <p className="city-info">
                  <svg className="icon phone-icon" />
                  0899 199 786
                </p>
              </div>
              <div className="city">
                <h4 className="city-title">TP Hồ Chí Minh CS2</h4>
                <p className="city-info">
                  <svg className="icon location-icon" />
                  Tầng 21 - AP Tower - 518B Điện Biên Phủ
                </p>
                <p className="city-info">
                  <svg className="icon phone-icon" />
                  024 6671 8334
                </p>
              </div>
            </div>
          </div>
        </div>

        {/* Company Info */}
        <div className="company-info">
          <img src={logo} alt="Company Logo" className="company-logo" />
          <div className="company-details">
            <p className="copyright">©Copyright 2014-2025</p>
            <p className="company-name">CÔNG TY CỔ PHẦN XHOME VIỆT NAM</p>
            <p className="company-address">
              Lancaster Building, 20 Núi Trúc - Giảng Võ - Ba Đình - Hà Nội
            </p>
            <p className="company-license">
              Giấy phép số 0106514703 do Sở kế hoạch và đầu tư thành phố Hà Nội cấp ngày 26/06/2020
            </p>
          </div>
        </div>

        <div className="hn-footer-bottom">
          <div className="hn-footer-copyright">
            © 2024 HaoNhien Studio. All rights reserved.
          </div>
          <div className="hn-footer-auth">
            {isAuthenticated ? (
              <div className="hn-user-menu">
                <span className="hn-username">Xin chào, {user?.username}</span>
                <div className="hn-auth-buttons">
                  <Link to="/manager/products" className="hn-manager-button">
                    Manager
                  </Link>
                  <button onClick={handleLogout} className="hn-logout-button">
                    Đăng Xuất
                  </button>
                </div>
              </div>
            ) : (
              <Link to="/login" className="hn-login-button">
                Đăng Nhập
              </Link>
            )}
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;